export default (value: string | null) => {
  const phoneRegEx = /^(0) ?\d{10}$/gi

  if (value && !value.match(phoneRegEx)) {
    return "Phone number is not valid"
  }

  return true
}
